import { useNavigate } from "react-router-dom";

function NavigationControl({styles}) {
    const navigate = useNavigate();

    return (
        <div>
            <button className={`btn ${styles}`} onClick={() => navigate(-1)}><i className="fa-solid fa-arrow-left"></i></button>
        </div>
    );
}

export default NavigationControl;